import React from 'react';
import { Helmet } from 'react-helmet-async';

const MetaVerification = () => {
  return (
    <Helmet>
      {/* Google Analytics Tag */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-FY6YE1L0QJ"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-FY6YE1L0QJ');
        `}
      </script>

      {/* Google AdSense Code */}
      <script async src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${import.meta.env.VITE_ADSENSE_CLIENT_ID}`} crossOrigin="anonymous" />
    </Helmet>
  );
};

export default MetaVerification;